import {
  withCallState,
  withModel,
  withModelCrud,
} from '@kinet-open-network/client/shared/data-access/state';
import { signalStore } from '@ngrx/signals';
import { CustomerBankAccount } from '../models/customer-bank-account.model';
import { CustomerBankAccountsService } from '../services/customer-bank-accounts.service';

export const CustomerBankAccountsStore = signalStore(
  withCallState(),
  withModel<CustomerBankAccount>(),
  withModelCrud(CustomerBankAccountsService),
);
